import React, { lazy, Suspense } from "react";
import PropTypes from "prop-types";

import { useSiteMetadata } from "../hooks/useSiteMetadata";

const ReCAPTCHA = lazy(() => import("react-google-recaptcha"));

const InvisibleReCAPTCHA = ({ innerRef, ...otherProps }) => {
    const {
        recaptcha: { siteKey },
    } = useSiteMetadata();

    const props = Object.assign({}, otherProps, {
        size: "invisible",
        sitekey: siteKey,
        ref: innerRef,
        onExpired: () => innerRef.current.reset(),
    });

    return (
        <Suspense fallback="">
            <ReCAPTCHA {...props} />
        </Suspense>
    );
};

InvisibleReCAPTCHA.propTypes = {
    innerRef: PropTypes.shape({ current: PropTypes.object }).isRequired,
};

export default InvisibleReCAPTCHA;
